import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../shared/shared-imports';
import { RoutesPath } from '../../../shared/constants/routes-path';
import { environment } from '../../../../environments/environment';

@Component({
  standalone: true,
  selector: 'app-forgot-username',
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS],
  templateUrl: './forgot-username.component.html',
  styleUrl: './forgot-username.component.css'
})
export class ForgotUsernameComponent {
  recoverForm: FormGroup;
  isSubmitting = false;
  isSuccess = false;
  supportEmail = environment.ssoSupportEmail;
  private readonly recoverUrl = `${environment.wso2APIURL}DCAuthToken/Recovery/RecoverUsername`;

  constructor(private fb: FormBuilder, private router: Router, private http: HttpClient) {
    this.recoverForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  showErrorMsg:boolean = false;
  submit() {
    if (this.recoverForm.invalid) {
      this.recoverForm.markAllAsTouched();
      return;
    }
    if (this.isSubmitting) {
      return;
    }
    this.showErrorMsg = false;
    this.isSubmitting = true;
    const { email } = this.recoverForm.value;
    this.http.post(this.recoverUrl, { email }).subscribe({
      next: (response:any) => {
        if(response?.status =='SUCCESS'){
          this.isSuccess = true;
        }else{
          this.showErrorMsg = true;
          this.isSubmitting = false;
        }
      },
      error: () => {
        this.isSubmitting = false;
      },
      complete: () => {
        this.isSubmitting = false;
      }
    });
  }

  cancel() {
    this.router.navigate(['/', RoutesPath.PUBLIC.LOGIN]);
  }

  backToApplication() {
    this.router.navigate(['/', RoutesPath.PUBLIC.LOGIN]);
  }
}
